import barlow800Url from '../../../assets/fonts/logo-templates/barlow-800.woff2?url';
import barlowCondensed400Url from '../../../assets/fonts/logo-templates/barlow-condensed-400.woff2?url';
import cinzel400Url from '../../../assets/fonts/logo-templates/cinzel-400.woff2?url';
import cinzel700Url from '../../../assets/fonts/logo-templates/cinzel-700.woff2?url';
import inter700Url from '../../../assets/fonts/logo-templates/inter-700.woff2?url';
import lora600Url from '../../../assets/fonts/logo-templates/lora-600.woff2?url';

export { barlow800Url, barlowCondensed400Url, cinzel400Url, cinzel700Url, inter700Url, lora600Url };

const FONT_FACE_CSS = `
@font-face {
  font-family: 'Inter';
  src: url('${inter700Url}') format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'Lora';
  src: url('${lora600Url}') format('woff2');
  font-weight: 600;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'Cinzel';
  src: url('${cinzel400Url}') format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'Cinzel';
  src: url('${cinzel700Url}') format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'Cinzel-Bold';
  src: url('${cinzel700Url}') format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'Cinzel-Regular';
  src: url('${cinzel400Url}') format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'Barlow Condensed';
  src: url('${barlowCondensed400Url}') format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'BarlowCondensed-Regular';
  src: url('${barlowCondensed400Url}') format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'Barlow';
  src: url('${barlow800Url}') format('woff2');
  font-weight: 800;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'Barlow-ExtraBold';
  src: url('${barlow800Url}') format('woff2');
  font-weight: 800;
  font-style: normal;
  font-display: block;
}
`;

let fontsPromise: Promise<void> | null = null;

export function ensureLogoTemplateFonts(): Promise<void> {
  const doc = typeof globalThis !== 'undefined' ? globalThis.document : undefined;
  if (!doc) return Promise.resolve();

  if (!fontsPromise) {
    fontsPromise = (async () => {
      if (!doc.getElementById('logo-template-fonts')) {
        const style = doc.createElement('style');
        style.id = 'logo-template-fonts';
        style.textContent = FONT_FACE_CSS;
        doc.head.appendChild(style);
      }

      if (doc.fonts?.ready) {
        await doc.fonts.ready;
      }

      // Force-load faces used by logos so getBBox is correct before first paint settle.
      await Promise.allSettled([
        doc.fonts.load("700 48px 'Cinzel'"),
        doc.fonts.load("400 40px 'Barlow Condensed'"),
        doc.fonts.load("800 48px 'Barlow'"),
        doc.fonts.load('700 48px Inter'),
        doc.fonts.load('600 48px Lora'),
      ]);

      if (doc.fonts?.ready) {
        await doc.fonts.ready;
      }
    })();
  }

  return fontsPromise;
}
